

<script>
import { Pie } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'

export default {
    extends: Pie,
    name: 'PieChart',
    props: {
        dataPie: {
            type: Object,
            required: true,
            validator(value) {
                return (
                    Array.isArray(value.labels) &&
                    Array.isArray(value.dataSet) &&
                    Array.isArray(value.colors)
                )
            }
        }
    },
    data() {
        return {
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {position: 'bottom'},
                plugins: [ChartDataLabels],  // <-- enregistrer le plugin ici
                datalabels: {
                    color: '#fff',
                    formatter: (value) => value,
                    font: {weight: 'bold', size: 14}
                }
            }
        }
    },
    mounted() {
        this.renderChart({
            labels: this.dataPie.labels,
            datasets: [
                {
                    data: this.dataPie.dataSet,
                    backgroundColor: this.dataPie.colors,
                    datalabels: {          // <-- déclaration spécifique par dataset
                        color: '#fff',
                        formatter: (value) => value,
                        font: {weight: 'bold', size: 14}
                    }
                }
            ]
        }, this.chartOptions)
    },
    watch: {
        dataPie: {
            handler() {
                this.renderChart({
                    labels: this.dataPie.labels,
                    datasets: [
                        {
                            data: this.dataPie.dataSet,
                            backgroundColor: this.dataPie.colors,
                            datalabels: {
                                color: '#fff',
                                formatter: (value) => value,
                                font: {weight: 'bold', size: 14}
                            }
                        }
                    ]
                }, this.chartOptions)
            },
            deep: true
        }
    }
}
</script>

<style scoped>
div {
    height: 300px;
}
</style>
